"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDataSet = void 0;
var tslib_1 = require("tslib");
exports.convertDataSet = function (dataset) {
    return tslib_1.__assign({}, dataset);
};
//# sourceMappingURL=DataSetConverter.js.map